import React from "react";
import Box from "@material-ui/core/Box";
import Link from "@material-ui/core/Link";
import Button from "@material-ui/core/Button";
import GetAppOutlinedIcon from "@material-ui/icons/GetAppOutlined";

export default function ManifestDl(props) {
  //Manifest Download
  return (
    <Box ml={1} mb={1}>
      {" "}
      <Link
        underline="none"
        className="manifestLink"
        href={props["manifestUrl"]}
        target="_blank"
        rel="noopener noreferrer"
        variant="inherit"
      >
        <Button
          startIcon={<GetAppOutlinedIcon fontSize="small" />}
          variant="contained"
        >
          IIIF Manifest
        </Button>
      </Link>
    </Box>
  );
}